/**
 * HTTP layer for operational compliance reports. The fixture-list,
 * disabled-relay-load, live-alarm-summary, curfew, and digital-maintenance
 * report feeds, plus a relay-load schedule Excel export.
 *
 * Contains:
 * - fetchFixtureReport / fetchDisabledRelayLoadReport / fetchAlarmLiveSummaryReport: site-group reports
 * - fetchDigitalMaintenanceReportsInRange / fetchCurfewReportPage / fetchMaintenanceReportPage: paged reports
 * - fetchRelayLoadsScheduleReportExcel: schedule Excel export
 */
import apiClient from '@sophocles/http-common';

export const fetchFixtureReport = siteGroupId =>
  apiClient.get(`/reports/fixturelist/${siteGroupId}/`).then(res => res.data);

export const fetchDisabledRelayLoadReport = siteGroupId =>
  apiClient.get(`/reports/disabledrelayloads/${siteGroupId}/`).then(res => res.data);

export const fetchAlarmLiveSummaryReport = (customerId, siteGroupId) =>
  apiClient
    .get(`/reports/alarmlivesummary/${customerId}/${siteGroupId ? `${siteGroupId}/` : ''}`)
    .then(res => res.data);

export const fetchDigitalMaintenanceReportsInRange = (siteGroupId, startTime, endTime) =>
  apiClient
    .get(`/digitalmaintenancereports/`, {
      params: {
        site__site_groups: siteGroupId,
        created_time__gte: startTime,
        created_time__lte: endTime,
      },
    })
    .then(res => res.data);

export const fetchCurfewReportPage = (customerId, params) =>
  apiClient.get(`/customers/${customerId}/curfewreport/`, { params }).then(res => res.data);

export const fetchMaintenanceReportPage = params =>
  apiClient.get('odl-app/maintenance-report/', { params }).then(res => res.data);

export const fetchRelayLoadsScheduleReportExcel = (filterKey, siteGroupId) =>
  apiClient
    .get(`/relayloads/schedule_report_export/?${filterKey}=${siteGroupId}`, { responseType: 'blob' })
    .then(res => res.data);
